<a class="menu-action" #userMenuTrigger [matMenuTriggerFor]="userMenu" (click)="salespointRoleComponent && salespointRoleComponent.resetChanges()"
   *ngIf="!routeService.isWindow" [ngClass]="{'active': isOpen}">
  <div class="menu-action-content body-1">
    <ng-container *ngIf="utilService.isMobile">
      <mat-icon class="svg-icon" [svgIcon]="'user_settings'" *ngIf="authService.user.isPrivateAccount"></mat-icon>
      <mat-icon class="svg-icon" [svgIcon]="'suitcase'" *ngIf="!authService.user.isPrivateAccount"></mat-icon>
    </ng-container>
    <ng-container *ngIf="authService.user">
      <span class="name desktop">{{ authService.user.firstName }} {{ authService.user.lastName }}</span>
      <span class="name mobile">{{ authService.user.firstName }} {{ authService.user.lastName.substring(0, 1) }}.</span>
      <span class="separator" *ngIf="!authService.user.isPrivateAccount">|</span>
      <span class="salespoint-name" *ngIf="authService.user.salespointName">
        {{ authService.user.salespointName + (!((authService.user.isSuperCentre || authService.user.isSubCentre) && authService.user.companyName) ?
           (' (' + authService.user.companyName + ')') : '') }}
      </span>
    </ng-container>
    <mat-icon class="svg-icon expand-arrow" [svgIcon]="'arrow_down'"></mat-icon>
  </div>
</a>
<mat-menu class="mat-menu user-menu" #userMenu="matMenu" yPosition="below" xPosition="before" backdropClass="user-menu-backdrop">
  <div class="user-menu-wrapper" (click)="$event.stopPropagation()">
    <div class="user-menu-main">
      <div class="mobile-width-fixer"></div>
      <div class="mobile">
        <div class="heading-2">{{ 'general.api_user_menu_account' | translate }}</div>
        <button mat-button class="icon-button close-menu" (click)="closeMenu()">
          <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
        </button>
      </div>
      <ng-container *ngIf="salespoints.length === 1">
        <div class="mobile-xxs bottom-spacer-x2" *ngIf="authService.user.isPrivateAccount">
          <div class="body-2 bold">{{ authService.user.firstName }} {{ authService.user.lastName }}</div>
        </div>
        <div class="mobile bottom-spacer-x2" *ngIf="!authService.user.isPrivateAccount">
          <ng-container *ngIf="!authService.user.isPromoter">
            <div class="body-2 bold">{{ authService.user.salespointName }}</div>
            <span class="title">{{ authService.user.companyName }}</span>
          </ng-container>
          <div class="body-2 bold" *ngIf="authService.user.isPromoter">{{ authService.user.companyName }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="authService.permissions?.length > 1">
        <app-salespoint-role #salespointRoleComponent></app-salespoint-role>
        <button mat-flat-button color="primary" class="max-width top-spacer bottom-spacer" (click)="salespointRoleComponent.switchRole(); closeMenu()"
                [disabled]="!salespointRoleComponent.isValid || !salespointRoleComponent.hasChanged">
          {{ 'general.api_user_menu_switch_role' | translate }}
        </button>
      </ng-container>
      <button mat-stroked-button class="max-width top-spacer bottom-spacer" color="primary" (click)="logout()">
        {{ 'general.api_login_logout' | translate }}
      </button>
      <button mat-button class="max-width bottom-spacer" [routerLink]="'/change-password'">
        {{ 'general.api_user_menu_change_password' | translate }}
      </button>
      <div class="nav-menu">
        <a class="nav-menu-item" (click)="myProfile(); closeMenu()" *ngIf="authService.user.isPrivateAccount">
          {{ 'general.api_menu_my_profile' | translate }}
        </a>
        <a class="nav-menu-item" (click)="businessProfile(); closeMenu()" *ngIf="!authService.user.isPrivateAccount && authService.hasLegalGetPrivilege">
          {{ 'general.api_menu_business_profile' | translate }}
        </a>
      </div>
      <a class="link bottom-spacer-x2" (click)="registerBusinessProfile(); closeMenu()" *ngIf="authService.user.isPrivateAccount && authService.hasLegalChangePrivilege">
        <mat-icon class="svg-icon valign-middle" [svgIcon]="'plus'"></mat-icon>
        <span>{{ 'general.api_menu_register_business_profile' | translate }}</span>
      </a>
      <div class="nav-footer">
        <div class="bold">{{ (authService.user.projectManager ? 'general.api_menu_my_administrator' : 'general.api_menu_contact_us') | translate }} <mat-icon *ngIf="authService.user.projectManager" class="svg-icon valign-middle" [svgIcon]="'info'" [matTooltip]="'general.api_menu_my_administrator_tooltip' | translate"></mat-icon></div>
        <div *ngIf="!authService.user.projectManager" [innerHTML]="authService.contactHtml | translate"></div>
        <div *ngIf="authService.user.projectManager">
          <div>{{ authService.user.projectManager.firstName }} {{ authService.user.projectManager.lastName }}</div>
          <div><a class="link" href="mailto:{{ authService.user.projectManager.email }}"><span>{{ authService.user.projectManager.email }}</span></a></div>
          <div>{{ authService.user.projectManager.phoneNr | phoneNumber }}</div>
        </div>
        <div class="align-center small top-spacer text-muted">{{ viewService.version }}
          <ng-container *ngIf="!!viewService.conf.environment"> | {{ viewService.conf.environment }}</ng-container>
        </div>
      </div>
    </div>
  </div>
</mat-menu>
